import { ChatAgentPermissions } from './chatAgent.permissions';
import { ChatAgentRoles } from './chatAgent.roles';

export const chatAgentMappings = {
  [ChatAgentPermissions.ACCESS_CHAT_AGENT]: [ChatAgentRoles.USER],
  [ChatAgentPermissions.ACCESS_GRAPHQL_MCP]: [ChatAgentRoles.GRAPHQL_MCP_USER],
  [ChatAgentPermissions.MANAGE_INSTRUCTIONS]: [
    ChatAgentRoles.INSTRUCTIONS_MANAGER,
  ],
};
